// extracted by mini-css-extract-plugin
module.exports = {"list":"Tabs_list__TWN8O","trigger":"Tabs_trigger__gquuJ","content":"Tabs_content__oDhWr","badge":"Tabs_badge___ZCyS"};